import axios from 'axios'
import qs from 'qs'
import store from '../../store'
/**
 * 每次get请求或者post请求之前，自动加token
 * @param newToken
 * @param customer
 */
let setAxiosToken = function( newToken, customer,imei ){
  // if( newToken !== oldToken ){
  // console.log( "TOKEN1:", newToken, oldToken );
  // console.error( "自定义Axios", newToken );
    axios.interceptors.request.use(
      function( config ){
        // axios.defaults.headers['Authorization'] = newToken;
        // console.log( "TOKEN2:", newToken, oldToken, config );
        if( config.method === 'post' ){
          // console.error( "TOKEN3:", newToken, oldToken );
          config.data = {
            token: newToken,
            appPlatform:"officeAccount",
            imei: $cookies.get('imei'),
            ...config.data,
          };
          // config.data = qs.stringify(config.data);
          config.params = {
            customer: customer,
            ...config.params,
          }
          // console.error(config.data);
          // config.data = JSON.stringify(config.data);
        }else if( config.method === 'get' ){
          config.params = {
            customer:customer,
            ...config.params,
            token: newToken,
          }
        }
        return config;
      }
    );
    axios.interceptors.response.use((res)=>{
      if(res.data.ret === 59){
        store.commit('deviceBindChange',true)
        return res
      }else{
        return res
      }
    })
  // }
};

export { setAxiosToken };
